import React from 'react';
import { connect } from 'react-redux';
import moment from "moment";

import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import WorkReportTemplate from './WorkReportTemplate';
import dailyReportService from '../../services/WorkReport/daily-report-service';
import employeeEmailService from '../../services/Employee/employee-email-service';
import {
	increaseDailyReportLoadCounter,
	fetchDailyReportList,
	setDailyReportFilter,
	updateDailyReport,
	submitDailyReport
} from '../../actions/work-report-actions';
import {
	Table,
	Button,
	Modal,
	Spin,
	message,
	Row,
	Col,
	Icon,
	Radio,
	DatePicker,
	Tag,
	Divider,
	Form,
	Input,
	Select

} from 'antd';
import logoImg from '../../assets/images/CJL-logo.png';
import { fetchEmployeesList } from '../../actions/employee-management-actions.js';
const webConfig = require('../../config.json');

class DailyReport extends React.Component {
	report_id_timer = 0;
	state = {
		currentModalStatus: false,
		can_submit: true,
		can_save: true,
		//report_id_timer: 0,
		currentDateModalStatus: false,
		loading: false,
		submitLoading: false,
		is_exist_email_account: true,
		isAddtion: false,
		currentData: {
			employee_id_1: '',
			employee_id_2: '',
			employee_id_3: ''
		},
		timer_saving: false,//计时器正在保存中
		can_edit: true

	}
	timer = null;
	rowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			let ids = selectedRows.map(row => row.id);
			this.setState({ selectedIDs: ids });
		},
		getCheckboxProps: record => ({
			disabled: record.status !== 0
		}),
	}

	componentWillMount() {
		var props = this.props;

		this.props.increaseDailyReportLoadCounter();
		if (this.props.routing.location.pathname.split('/')[3]) {
			this.setState({
				openDetail: false,
				currentModalStatus: true,
				currentDateModalStatus: true
			});
			dailyReportService.initDailyReport({ type_id: 1 }, res => {
				this.setState({
					dailyReportTemplate: JSON.parse(res.data.template),
					real_name: res.data.employee.real_name,
					department_name: res.data.employee.department_name,
					position_name: res.data.employee.position_name,
					district: res.data.district,
					type_id: res.data.type_id,
					report_id: null,
					iscocy: res.data.template_name === "日工作报告(行销部)",
					isAddtion: res.data.template_name === "小鹿之星",
					currentData: {
						question: "",
						employee_id_1: "",
						employee_id_2: "",
						employee_id_3: "",
						employee_1_reason: "",
						employee_2_reason: "",
						employee_3_reason: "",
					}
				});
			});
		}

		this.fetchEmployeeEmailDetail()

	}

	fetchEmployeeEmailDetail = () => {
		employeeEmailService.fetchEmployeeEmailDetail({}, res => {
			console.log(res)
			if (!res.data) {
				this.setState({ is_exist_email_account: false })
			}
		})
	}



	componentWillReceiveProps(nextProps) {
		if (nextProps.workReport.dailyReportLoadCounter !== this.props.workReport.dailyReportLoadCounter) {
			let gets = { type_id: 1 };
			Object.keys(nextProps.workReport.dailyReportFilters).forEach(key => {
				if (nextProps.workReport.dailyReportFilters[key]) {
					gets[key] = nextProps.workReport.dailyReportFilters[key];
				}
			});
			this.props.fetchDailyReportList(gets);
		}
	}

	componentWillUnmount() {
		this.timer && clearInterval(this.timer)
	}

	setStartDateFilter = (value, date) => {
		this.props.setDailyReportFilter({ start_date: date, page: 1 });
	}
	setStartDate = (val) => {
		if (val) {
			val = val.format("YYYY-MM-DD")
			//去确认当前日期是否有未提交的日报
			dailyReportService.confirmDateAllow({ date: val }, res => {
				if (!res.data.Success) {

					message.error('当前日期有未提交日报')
					this.setState({
						currentDateModalStatus: false
					});
					this.closeCurrentModal()
				} else {
					this.setState({ date_1: val });
				}
			})
		}
		// console.log(this.state.date_1);
	}

	setEndDateFilter = (value, date) => {
		this.props.setDailyReportFilter({ end_date: date, page: 1 });
	}

	setStatusFilter = event => {
		this.props.setDailyReportFilter({ status: event.target.value, page: 1 });
	}

	setPageFilter = pagination => {
		this.props.setDailyReportFilter({ page: pagination.current });
	}

	newDailyReport = () => {
		this.setState({
			openDetail: false,
			currentModalStatus: true,
			currentDateModalStatus: true
		});
		dailyReportService.initDailyReport({ type_id: 1 }, res => {
			this.setState({
				dailyReportTemplate: JSON.parse(res.data.template),
				real_name: res.data.employee.real_name,
				department_name: res.data.employee.department_name,
				position_name: res.data.employee.position_name,
				district: res.data.district,
				type_id: res.data.type_id,
				report_id: null,
				date_1: null,
				iscocy: res.data.template_name === "日工作报告(行销部)",
				isAddtion: res.data.template_name === "小鹿之星",
				currentData: {
					question: "",
					employee_id_1: "",
					employee_id_2: "",
					employee_id_3: "",
					employee_1_reason: "",
					employee_2_reason: "",
					employee_3_reason: "",
				}
			});
		});

	}
	//选中时间后确定
	submitWorkDate = () => {
		console.log(this.state.date_1)
		if (!this.state.date_1) {
			message.error('请选择日报时间')
		} else {
			this.setState({ currentDateModalStatus: false })
		}
		//选中时间后,开启计时器,每隔一段时间(20s)保存一次
		// this.timer = setInterval(
		// 	() => {
		// 		//开始计时器
		// 		//执行保存操作
		// 		this.saveCurrentReportByTimer()
		// 	},
		// 	20000
		// );
	}
	//计时器保存
	saveCurrentReportByTimer = () => {
		if (!this.state.date_1) {
			return false;
		}

		this.setState({ timer_saving: true })
		this.props.form.validateFields((err, values) => {
			let posts = {
				status: 0,
				table_content: JSON.stringify(this.state.dailyReportTemplate),
				type_id: this.state.type_id,
				date_1: this.state.date_1,
				best_employees: {
					employee_id_1: this.state.currentData.employee_id_1,
					employee_id_2: this.state.currentData.employee_id_2,
					employee_id_3: this.state.currentData.employee_id_3,
					employee_1_reason: values.employee_1_reason,
					employee_2_reason: values.employee_2_reason,
					employee_3_reason: values.employee_3_reason,
				},
				question: values.question,
			}
			if (!values.employee_id_1) {
				posts.best_employees.employee_id_1 = '';
			}
			if (!values.employee_id_2) {
				posts.best_employees.employee_id_2 = '';
			}
			if (!values.employee_id_3) {
				posts.best_employees.employee_id_3 = '';
			}
			dailyReportService.updateDailyReport(posts, res => {
				if (res.data.Success) {
					//this.state.report_id_timer = res.data.ModelId
					//this.setState({report_id_timer:res.data.ModelId});
					this.report_id_timer = res.data.ModelId
					this.setState({ timer_saving: false })
					this.props.increaseDailyReportLoadCounter();
				}
			});
		})

	}

	saveCurrentReport = status => {
		if (this.state.timer_saving) {
			message.error("正在自动保存,请稍后重新点击保存", 4);
			return false;
		}
		if (!this.state.date_1) {
			message.error("请选择日期", 4);
			return false;
		}
		if (!this.state.currentData.employee_id_1 && this.state.employee1_search && this.state.employee1_search.length > 0) {
			message.error("请选择小鹿之星1或者清空小鹿之星1文本框", 4);
			return false;
		}
		if (!this.state.currentData.employee_id_2 && this.state.employee2_search) {
			message.error("请选择小鹿之星2或者清空小鹿之星2文本框", 4);
			return false;
		}
		if (!this.state.currentData.employee_id_3 && this.state.employee3_search) {
			message.error("请选择小鹿之星3或者清空小鹿之星3文本框", 4);
			return false;
		}

		if (status === 1) {
			this.setState({ submitLoading: true })
		} else {
			this.setState({ loading: true })
		}
		if (this.state.can_save) {
			this.state.can_save = false;
			this.props.form.validateFields((err, values) => {
				let posts = {
					status: status,
					table_content: JSON.stringify(this.state.dailyReportTemplate),
					type_id: this.state.type_id,
					date_1: this.state.date_1,
					best_employees: {
						employee_id_1: this.state.currentData.employee_id_1,
						employee_1_reason: values.employee_1_reason,
						employee_id_2: this.state.currentData.employee_id_2,
						employee_2_reason: values.employee_2_reason,
						employee_id_3: this.state.currentData.employee_id_3,
						employee_3_reason: values.employee_3_reason,
					},
					question: values.question,
				}
				if (!posts.table_content) {
					message.error("报告内容不能为空", 4);
					this.setState({ loading: false, submitLoading: false })
					return;
				}
				if (!values.employee_id_1) {
					posts.best_employees.employee_id_1 = '';
				}
				if (!values.employee_id_2) {
					posts.best_employees.employee_id_2 = '';
				}
				if (!values.employee_id_3) {
					posts.best_employees.employee_id_3 = '';
				}
				this.setState({ can_edit: false })
				if (this.state.report_id) {
					posts = {
						...this.props.workReport.dailyReportData.Data[this.state.currentIndex],
						...posts
					}

					this.props.updateDailyReport(posts, this.state.currentIndex, result => {
						this.setState({ loading: false, submitLoading: false })
						this.setState({ can_edit: true })
						if (result) {
							this.closeCurrentModal();
							message.success("保存日报成功", 4);
							this.timer && clearInterval(this.timer)
							this.props.increaseDailyReportLoadCounter();
							this.fetchEmployeeEmailDetail();
						} else {
							message.error("保存日报失败", 4);
							this.state.can_save = true;
						}
						this.report_id_timer = 0
					});
				} else {
					if (this.report_id_timer !== 0) {
						posts = {
							...posts,
							id: this.report_id_timer
						}
						dailyReportService.updateDailyReport(posts, res => {
							this.setState({ loading: false, submitLoading: false })
							this.setState({ can_edit: true })
							if (res.data.Success) {
								this.closeCurrentModal();
								message.success("保存日报成功", 4);
								this.props.increaseDailyReportLoadCounter();
								this.timer && clearInterval(this.timer)
							} else {
								message.error("保存日报失败" + res.data.Errors[0], 4);
								this.state.can_save = true;
							}

							this.report_id_timer = 0
						})

					} else {
						dailyReportService.saveDailyReport(posts, res => {
							this.setState({ loading: false, submitLoading: false })
							this.setState({ can_edit: true })
							if (res.data.Success) {
								this.closeCurrentModal();
								message.success("保存日报成功", 4);
								this.props.increaseDailyReportLoadCounter();
								this.timer && clearInterval(this.timer)
								this.fetchEmployeeEmailDetail();
							} else {
								message.error("保存日报失败" + res.data.Errors[0], 4);
								this.state.can_save = true;
							}
						});
					}
				}
			})
		}
	}


	submitCurrentReport = status => {
		Modal.confirm({
			title: '确定提交报告?报告一旦提交,将无法再修改.',
			okText: '确认',
			cancelText: '取消',
			onOk: () => this.saveCurrentReport(status),
			onCancel: () => {

			}
		});
	}

	editReportContent = reportContent => {
		this.setState({ dailyReportTemplate: reportContent });
	}

	closeCurrentModal = () => {
		this.setState({ currentModalStatus: false, can_submit: true, can_save: true });
		this.setState({ currentData: null });
		this.setState({ employee1_search: null });
		this.setState({ employee2_search: null });
		this.setState({ employee3_search: null });
		this.timer && clearInterval(this.timer)
	}
	closeDateCurrentModal = () => {
		this.setState({
			currentDateModalStatus: false
		});
		this.closeCurrentModal()
	}
	updateDailyReport = (record, index, unedit) => {
		this.setState({
			openDetail: unedit,
			currentIndex: index,
			currentModalStatus: true
		});

		dailyReportService.fetchDailyReportDetail({ modelId: record.id }, res => {
			console.log(res.data)
			this.setState({
				dailyReportTemplate: JSON.parse(res.data.work_report.table_content),
				real_name: res.data.employee.real_name,
				department_name: res.data.employee.department_name,
				position_name: res.data.employee.position_name,
				district: res.data.district,
				type_id: res.data.work_report.type_id,
				next_id: res.data.next_id,
				prev_id: res.data.prev_id,
				replies: res.data.replies,
				report_id: res.data.work_report.id,
				date_1: res.data.work_report.date_1,
				iscocy: res.data.work_report.template_name === "日工作报告(行销部)",
				isAddtion: res.data.work_report.template_name === "小鹿之星",
				currentData: {
					employee_id_1: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_id_1 ? res.data.work_report.best_employees.employee_id_1 : "",
					employee_1_reason: res.data.work_report.best_employees ? res.data.work_report.best_employees.employee_1_reason : "",
					employee_id_2: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_id_2 ? res.data.work_report.best_employees.employee_id_2 : "",
					employee_2_reason: res.data.work_report.best_employees ? res.data.work_report.best_employees.employee_2_reason : "",
					employee_id_3: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_id_3 ? res.data.work_report.best_employees.employee_id_3 : "",
					employee_3_reason: res.data.work_report.best_employees ? res.data.work_report.best_employees.employee_3_reason : "",
					employee_name_1: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_name_1 ? res.data.work_report.best_employees.employee_name_1 : "",
					employee_name_2: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_name_2 ? res.data.work_report.best_employees.employee_name_2 : "",
					employee_name_3: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_name_3 ? res.data.work_report.best_employees.employee_name_3 : "",
					question: res.data.work_report.question
				},
			});

		});
		console.log(123456)
		// if (!unedit) {
		// 	//打开编辑后,开启计时器,每隔一段时间(20s)保存一次
		// 	this.timer = setInterval(
		// 		() => {
		// 			//开始计时器
		// 			//执行保存操作
		// 			this.saveCurrentReportByTimer()
		// 		},
		// 		20000
		// 	);
		// }

	}
	CopyDailyReport = () => {
		dailyReportService.copyDailyReport({}, res => {
			this.setState({
				dailyReportTemplate: JSON.parse(res.data.template),
			});
		});
	}
	submitReport = (record, index) => {
		Modal.confirm({
			title: '确定提交报告?报告一旦提交,将无法再修改.',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				this.setState({ loading: true })
				let puts = {
					...record,
					status: 1
				}
				this.setState({ can_edit: false })
				this.props.submitDailyReport(puts, index, result => {
					this.setState({ can_edit: true })
					if (result) {
						message.success("提交报告成功", 4);
						this.props.increaseDailyReportLoadCounter();
						//更新员工邮件授权
						this.fetchEmployeeEmailDetail()

					} else {
						message.error("提交报告失败", 4);
						this.state.can_submit = true;
					}
					this.setState({ loading: false })
					this.report_id_timer = 0
				});
			},
			onCancel: () => { }
		});
	}
	EmailRetryDailyReport = (record) => {
		Modal.confirm({
			title: '确定重发邮件吗?',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				console.log(record)
				let puts = {
					id: record.id
				}
				dailyReportService.emailRetryDailyWorkReport(puts, result => {
					if (result.data.Success) {
						message.success("重发成功", 4);
						this.props.increaseDailyReportLoadCounter();
						this.fetchEmployeeEmailDetail()
					} else {
						message.error("重发失败", 4);
					}
				});
			},
			onCancel: () => { }
		});
	}
	multiDeleteDailyReport = () => {
		if (!this.state.selectedIDs || 0 === this.state.selectedIDs.length) {
			message.error('请选择要删除的报告', 4);
			return false;
		}
		Modal.confirm({
			title: '确定删除选中的内容么?',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				dailyReportService.multiDeleteDailyReport({ ids: this.state.selectedIDs }, res => {
					if (res.data.Success) {
						message.success('删除报告成功', 4);
						this.props.increaseDailyReportLoadCounter();
					} else {
						message.error('删除报告失败' + res.data.Errors, 4);
					}
				});
			},
			onCancel: () => { }
		});
	}

	formColumn = [{
		label: "1",
		key: "employee_id_1",
		type: "employee",
		span: 24
	}, {
		label: "2",
		key: "employee_id_2",
		type: "employee",
		span: 24
	}, {
		label: "3",
		key: "employee_id_3",
		type: "employee",
		span: 24
	}
	]

	selectEmployee1 = value => {
		this.setState({ employee1_search: value });

		this.props.fetchEmployeesList({ real_name: value, for_all: true });
	}
	selectEmployee2 = value => {

		this.setState({ employee2_search: value });
		this.props.fetchEmployeesList({ real_name: value, for_all: true });
	}
	selectEmployee3 = value => {
		this.setState({ employee3_search: value });
		this.props.fetchEmployeesList({ real_name: value, for_all: true });
	}
	setBest1 = (value, event) => {
		let a = 11;
		this.setState({
			// employee_id_1: event.props.employee_id
			currentData: {
				...this.state.currentData,
				employee_id_1: event.props.employee_id
			}
		})
	}

	setBest2 = (value, event) => this.setState({
		currentData: {
			...this.state.currentData,
			employee_id_2: event.props.employee_id
		}
	})

	setBest3 = (value, event) => this.setState({
		currentData: {
			...this.state.currentData,
			employee_id_3: event.props.employee_id
		}
	})

	authorization = () => this.props.form.validateFields((err, values) => {

		if (!err) {
			const submitData = {
				...values
			}
			employeeEmailService.AddEmployeeEmail(submitData, result => {
				if (result.data.Success) {
					message.success("授权成功", 4);
					this.setState({ is_exist_email_account: true });
				} else {
					message.error("授权失败,请联系管理员", 4);
				}
			})

		} else {
			console.log(err);
		}
	})

	render() {
		const reportColumn = [{
			title: <div><div>报告时间</div><div>Report Time</div></div>,
			dataIndex: 'created_time_str',
			key: 'created_time',
			className: "table-global-head-small",
		}, {
			title: <div><div>回复时间</div><div>Reply Time</div></div>,
			dataIndex: 'reply_time_str',
			key: 'reply_time',
			className: "table-global-head-small",
		}, {
			title: <div><div>状态</div><div>Status</div></div>,
			dataIndex: 'status_name',
			key: 'status_name',
			className: "table-global-head-small",
		}, {
			title: <div><div>邮件状态</div><div>Email Status</div></div>,
			dataIndex: 'email_send_status',
			key: 'email_send_status',
			className: "table-global-head-small",
			render: value => {
				let color = ''
				let status_str = ''
				if (value == 4) {
					color = 'red'
					status_str = '失败'
					return <Tag color={color} key={value}>{status_str}</Tag>
				} else if (value == 3) {
					status_str = '成功'
					return <Tag color={color} key={value}>{status_str}</Tag>
				}
				return ''

			}
		}, {
			title: <div><div>操作</div><div>Action</div></div>,
			dataIndex: 'action',
			key: 'action',
			className: "table-global-head-small",
			render: (text, record, index) => (
				<span>
					{record.status === 0 ?
						<span>
							{(this.props.access.myDailyReport.u_value || this.props.access.employeeMyDailyReport.u_value) &&
								<Button icon="edit" size="small" className="row-action-btn" disabled={!this.state.can_edit}
									onClick={this.updateDailyReport.bind(this, record, index, false)}>编辑 Edit</Button>
							}
							{/*{(this.props.access.myDailyReport.submit_value || this.props.access.employeeMyDailyReport.c_value) &&*/}
							{/*	<Button icon="save" size="small" className="row-action-btn" disabled={!this.state.can_edit}*/}
							{/*		onClick={this.submitReport.bind(this, record, index)}>提交 Submit</Button>*/}
							{/*}*/}
						</span>
						:
						<span>
							{(this.props.access.myDailyReport.detail_value || this.props.access.employeeMyDailyReport.c_value) &&

								<Button icon="edit" size="small" className="row-action-btn"
									onClick={this.updateDailyReport.bind(this, record, index, true)}>详情 View</Button>

							}
							{(this.props.access.myDailyReport.detail_value || this.props.access.employeeMyDailyReport.c_value) && record.email_send_status == 4 &&

								<Button icon="info-circle-o" size="small" className="row-action-btn"
									onClick={this.EmailRetryDailyReport.bind(this, record)}>重发 Retry </Button>

							}
						</span>}
				</span>
			)
		}];

		return (
			<div className="app-module-item" >
				<Modal width="500px"
					zIndex={2}
					visible={this.state.currentDateModalStatus}
					title="请选择日报时间"
					destroyOnClose={true}
					onCancel={this.closeDateCurrentModal}
					onOk={this.submitWorkDate}
				>
					<Row>
						<Col>
							<span style={{ fontWeight: "bold" }}>Date 日期 : </span>
							<DatePicker onChange={this.setStartDate}
								value={this.state.date_1 ? moment(this.state.date_1, "YYYY-MM-DD") : null} />
						</Col>
					</Row>
				</Modal>


				{/* 员工邮箱 */}
				<Modal width="800px"
					// visible={!this.state.is_exist_email_account}
					visible={false}
					closable={false}
					title="邮箱授权"
					destroyOnClose={true}
					footer={<Button type="primary" size="default" onClick={this.authorization}>
						<span>授权</span>
					</Button>}>
					<div className="app-modal-item">
						<Form layout="inline">
							<Row>
								<Col span={24}>
									<Form.Item label="邮箱用户名">
										{this.props.form.getFieldDecorator('email_name', {
											rules: [{ required: true, message: '请输入邮箱用户名' }, {
												pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
												message: "请输入合法邮箱"
											}],
										})(<Input
											placeholder={"请输入邮箱用户名"}
											style={{ width: 300 }} />)}
									</Form.Item>
								</Col>
								<Col span={24}>
									<Form.Item label="邮箱密码">
										{this.props.form.getFieldDecorator('email_password', {
											rules: [{ required: true, message: '请输入邮箱密码' }]
										})(<Input
											type="password"
											placeholder={"请输入邮箱密码"}
											style={{ width: 300 }} />)}
									</Form.Item>
								</Col>
							</Row>
						</Form>
					</div>
				</Modal>



				<Modal width="1000px"
					keyboard={false}
					zIndex={1}
					visible={this.state.currentModalStatus}
					title="&nbsp;"
					maskClosable={false}
					destroyOnClose={true}
					onCancel={this.closeCurrentModal}
					footer={[
						(this.props.access.myDailyReport.save_value || this.props.access.employeeMyDailyReport.c_value) && this.state.openDetail ? null : <Button key="保存" type="primary"
							onClick={this.saveCurrentReport.bind(this, 0)} disabled={this.state.loading} loading={this.state.loading}>保存 Save</Button>,
						(this.props.access.myDailyReport.submit_value || this.props.access.employeeMyDailyReport.c_value) && this.state.openDetail ? null :
							<Button key="提交" type="primary"
								onClick={this.submitCurrentReport.bind(this, 1)} disabled={this.state.submitLoading} loading={this.state.submitLoading}>提交 Submit</Button>,
						// <Button key="关闭" onClick={this.closeCurrentModal} disabled={this.state.timer_saving}>关闭 Close</Button>,
					]}>

					<div style={{ textAlign: "center", margin: "0px 0px 5px", height: "700px", overflowY: "auto", padding: "0px 15px" }}>
						<Row style={{}}>
							{this.state.iscocy && <div style={{ textAlign: "right" }}><Button type="primary" onClick={this.CopyDailyReport}>
								<span>复制日报</span>
							</Button>
								<div style={{ height: "10px", border: "0" }}></div></div>}
							<Col span={18} style={{ fontSize: "32px", height: "95px", lineHeight: "40px", textAlign: "left" }}>

								<span style={{ fontWeight: "bold" }}>Daily Work Report</span><br />
								<span style={{ fontSize: "20px", fontWeight: "bold", paddingLeft: "5px" }}>日工作报告</span>
							</Col>
							<Col span={6} style={{ fontSize: "16px", height: "30px", lineHeight: "30px", textAlign: "right" }}>
								<span style={{}}>{this.state.district}</span>
							</Col>
						</Row>
						<Row style={{ fontSize: "16px", paddingTop: "15px" }}>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Name 姓名 : </span>
								<span style={{ fontSize: "14px", paddingLeft: "15px" }}>{this.state.real_name}</span>
							</Col>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Date 日期 : </span>
								<DatePicker onChange={this.setStartDate}
									value={this.state.date_1 ? moment(this.state.date_1, "YYYY-MM-DD") : null} />
							</Col>
						</Row>
						<Row style={{ fontSize: "16px", paddingBottom: "15px" }}>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Department 部门 : </span>
								<span style={{ fontSize: "14px", paddingLeft: "15px" }}>{this.state.department_name}</span>
							</Col>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Position 岗位 : </span>
								<span style={{ fontSize: "14px", paddingLeft: "15px" }}>{this.state.position_name}</span>
							</Col>
						</Row>

						<WorkReportTemplate currentData={this.state.dailyReportTemplate}
							editReportContent={this.editReportContent}
							openDetail={this.state.openDetail} />

						{/* 日报额外添加(小鹿之星) */}
						{this.state.isAddtion &&
							<div>
								<Row style={{ fontSize: "16px", border: "1px solid #cccccc" }}>
									<Col span={24} style={{ height: "40px", lineHeight: "40px", borderWidth: "0px 1px 1px", borderStyle: "solid", borderColor: "#cccccc" }}>
										<div style={{ backgroundColor: "#1a1a1a", minHeight: "40px", lineHeight: "40px", padding: "0px 35px", textAlign: "left", fontSize: "17px", color: "#ffffff" }}>
											请选您心目中的“小鹿之星”并举例说明或分享他的故事
                  </div>
									</Col>

									<Col span={24} style={{ textAlign: "center" }}>
										<div style={{ padding: "10px", border: "1px solid #cccccc" }}>
											<Form.Item label="">
												{this.props.form.getFieldDecorator("employee_id_1", {
													rules: [{
														required: false,
														message: ''
													}],
													initialValue: this.state.currentData && this.state.currentData.employee_name_1
												})(
													<Select mode="combobox"
														style={{ width: "100%" }}
														onSearch={this.selectEmployee1}
														filterOption={false}
														onSelect={this.setBest1}
														placeholder={""} >
														{this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
															this.props.employeeManagement.employeeList.Data.map(employee => {
																return (
																	<Select.Option key={employee.id}
																		value={employee.english_name}
																		employee_id={employee.id}
																		style={{ width: "100%", paddingLeft: "20px" }}>
																		{employee.english_name}
																	</Select.Option>
																)
															})}
													</Select>
												)}
											</Form.Item>
											<Form.Item label="">
												{this.props.form.getFieldDecorator("employee_1_reason", {
													initialValue: this.state.currentData && this.state.currentData.employee_1_reason
												})(
													<Input.TextArea rows={8} autosize={{ minRows: 4, maxRows: 999 }}
														placeholder={"请输入推荐原因"}
														style={{ width: "98%" }} />

													// <Input placeholder="推荐原因" style={{ width: "100%", color: "#000000" }} />

												)}
											</Form.Item>
										</div>
									</Col>
									<Col span={8} style={{ textAlign: "center" }}>
										<div style={{ padding: "10px", border: "1px solid #cccccc", display: "none" }}>
											<Form.Item label="">
												{this.props.form.getFieldDecorator("employee_id_2", {
													rules: [{
														required: false,
														message: ''
													}],
													initialValue: this.state.currentData && this.state.currentData.employee_name_2
												})(
													<Select mode="combobox"
														style={{ width: "220px" }}
														onSearch={this.selectEmployee2}
														filterOption={false}
														onSelect={this.setBest2}
														placeholder={""}>
														{this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
															this.props.employeeManagement.employeeList.Data.map(employee => {
																return (
																	<Select.Option key={employee.id}
																		value={employee.english_name}
																		employee_id={employee.id}
																		style={{ width: "200px", paddingLeft: "20px" }}>
																		{employee.english_name}
																	</Select.Option>
																)
															})}
													</Select>
												)}
											</Form.Item>
											<Form.Item label="">
												{this.props.form.getFieldDecorator("employee_2_reason", {
													initialValue: this.state.currentData && this.state.currentData.employee_2_reason
												})(

													<Input placeholder="推荐原因" style={{ width: "220px", color: "#000000" }} />

												)}
											</Form.Item>
										</div>
									</Col>
									<Col span={8} style={{ textAlign: "center" }}>
										<div style={{ padding: "10px", border: "1px solid #cccccc", display: "none" }}>
											<Form.Item label="">
												{this.props.form.getFieldDecorator("employee_id_3", {
													rules: [{
														required: false,
														message: ''
													}],
													initialValue: this.state.currentData && this.state.currentData.employee_name_3
												})(
													<Select mode="combobox"
														style={{ width: "220px" }}
														onSearch={this.selectEmployee3}
														filterOption={false}
														onSelect={this.setBest3}
														placeholder={""} >
														{this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
															this.props.employeeManagement.employeeList.Data.map(employee => {
																return (
																	<Select.Option key={employee.id}
																		value={employee.english_name}
																		employee_id={employee.id}
																		style={{ width: "200px", paddingLeft: "20px" }}>
																		{employee.english_name}
																	</Select.Option>
																)
															})}
													</Select>
												)}
											</Form.Item>
											<Form.Item label="">
												{this.props.form.getFieldDecorator("employee_3_reason", {
													initialValue: this.state.currentData && this.state.currentData.employee_3_reason
												})(
													<Input.TextArea rows={8} autosize={{ minRows: 4, maxRows: 999 }}
														placeholder={"请输入推荐原因"}
														style={{ width: "98%" }} />
													// <Input placeholder="推荐原因" style={{ width: "220px", color: "#000000" }} />

												)}
											</Form.Item>
										</div>
									</Col>
								</Row>
								<div
									style={{ minHeight: "30px", lineHeight: "30px", border: "1px solid #cccccc", padding: "5px 15px" }}>
									<Input.TextArea disabled={true} style={{ color: "#000" }} value={`评选标准：
1. 自驱力强使命感驱动的人: 努力行动、心态积极，自动自发，百分百投入。为了给客户服务可以付出一切的人。为了企业生存可以付出自己的利益的人。
2. 拥抱变化、极致开放：面对变化，理性对待，充分沟通，诚意配合。对变化产生的困难和挫折，能自我调整，并正面影响和带动同事。超强学习能力的人、能解决问题、务实的精神。工作中充分表达自己的意见，并以开放的心态接受一切正面和负面的反馈，勇于承担错误，将负面的反馈和错误视为学习的机会。
3. 超级客户思维：尊重维护同理客户，随时随地维护长颈鹿形象。积极主动在工作中为客户找到更好的解决方案，不推诿责任，有超前防范意识，防范于未然。有敬畏之心，敏锐的发现客户的需求，主动、付出。
4. 责任敬业：上班时间只做与工作有关的事情；今天的事不推到明天，持续学习，自我完善，做事情充分体现以结果为导向。能根据轻重缓急来正确安排工作优先级，做正确的事。遵循但不拘泥于工作流程，化繁为简，用较小的投入获得较大的工作成果。
5. 其他：团队协作、创新、沟通充分、冠军思维、诚信包容等等。
											`} rows={5} autosize={{ minRows: 2, maxRows: 999 }}
									/>
								</div>

								<div style={{ height: "10px", border: "0" }}></div>
								<Row style={{ fontSize: "16px", border: "1px solid #cccccc" }}>
									<Col span={24} style={{ height: "40px", lineHeight: "40px", borderWidth: "0px 1px 1px", borderStyle: "solid", borderColor: "#cccccc" }}>
										<div style={{ backgroundColor: "#1a1a1a", minHeight: "40px", lineHeight: "40px", padding: "0px 35px", textAlign: "left", fontSize: "17px", color: "#ffffff" }}>
											问题反馈或给团队的建议(包括学员、家长、与其他部门沟通事项)
                  </div>
									</Col>
									<Col span={24} >
										<div style={{ minHeight: "40px", lineHeight: "40px", border: "1px solid #cccccc", padding: "5px 15px" }}>
											<Form.Item>
												{this.props.form.getFieldDecorator("question", {
													rules: [{ required: false }],
													initialValue: this.state.currentData && this.state.currentData.question
												})(<Input.TextArea rows={8} autosize={{ minRows: 4, maxRows: 999 }}
													placeholder={"请输入问题反馈"}
													style={{ width: "98%" }} />)}
											</Form.Item>
										</div>
									</Col>
								</Row>
							</div>
						}


						{this.state.openDetail &&
							<div style={{ textAlign: "left", lineHeight: "30px", margin: "15px 0px" }}>
								<p>报告回复列表 : </p>
								{this.state.replies && this.state.replies.map(reply => {
									return (<div key={reply.id}>
										<span style={{ color: "blue" }}>{reply.real_name}</span>
										<span> ( </span>
										<span style={{ color: "blue" }}>
											{reply.reply_time ? moment(reply.reply_time).format("YYYY-MM-DD HH:MM") : ""}
										</span>
										<span> ) </span>
										<span> 回复 : </span>
										<span>{reply.content}</span>
									</div>)
								})}
							</div>}
						<hr style={{ height: "1px", border: "none", borderTop: "3px solid #555555" }} />
						<div>
							<img src={logoImg} alt="logo" style={{ float: "left", width: "110px", height: "auto" }} />
							<div style={{ float: "right", fontSize: "12px", height: "18px", lineHeight: "16px", textAlign: "left" }}><span>Tel: 400 6666 321</span><br /><span>www.egiraffe.com.cn</span><br /><span>GSH.20171101</span></div>
						</div>
					</div>
				</Modal>
				<div style={{ marginBottom: "20px" }}>
					{(this.props.access.myDailyReport.c_value || this.props.access.employeeMyDailyReport.c_value) &&
						<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
							<Button type="primary" onClick={this.newDailyReport}>
								<Icon type="plus-circle-o" />
								<span>新增 New</span>
							</Button>
						</div>
					}
					{(this.props.access.myDailyReport.d_value || this.props.access.employeeMyDailyReport.d_value) &&
						<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
							<Button type="primary" onClick={this.multiDeleteDailyReport}>
								<Icon type="delete" />
								<span>批量删除 Batch Delete</span>
							</Button>
						</div>
					}
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<span style={{ marginRight: "5px" }}>开始时间 Start Time: </span>
						<DatePicker onChange={this.setStartDateFilter}
							value={this.props.workReport.dailyReportFilters.start_date ?
								moment(this.props.workReport.dailyReportFilters.start_date, "YYYY-MM-DD") :
								null} />
					</div>
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<span style={{ marginRight: "5px" }}>结束时间 End Time: </span>
						<DatePicker onChange={this.setEndDateFilter}
							value={this.props.workReport.dailyReportFilters.end_date ?
								moment(this.props.workReport.dailyReportFilters.end_date, "YYYY-MM-DD") :
								null} />
					</div>
					<div className="colAction" style={{ float: "right", margin: "0px 10px 10px 0px" }}>
						<Radio.Group defaultValue={this.props.workReport.dailyReportFilters.status}
							onChange={this.setStatusFilter}>
							<Radio.Button value={false}>全部 All</Radio.Button>
							<Radio.Button value="0">未提交 Unsubmit</Radio.Button>
							<Radio.Button value="1">未回复 Unreply</Radio.Button>
							<Radio.Button value="2">已回复 Replied</Radio.Button>
						</Radio.Group>
					</div>
					<div style={{ clear: "both" }}></div>
				</div>
				{"loaded" === this.props.workReport.dailyReportStatus && <Table
					loading={this.state.loading}
					columns={reportColumn} dataSource={this.props.workReport.dailyReportData.Data}
					rowKey={record => record.id} rowSelection={this.rowSelection}
					pagination={{
						total: this.props.workReport.dailyReportData.Total,
						pageSize: this.props.workReport.dailyReportData.PageSize,
						current: this.props.workReport.dailyReportFilters.Page
					}}
					onChange={this.setPageFilter} />}
				{"unload" === this.props.workReport.dailyReportStatus && <div style={{ textAlign: 'center', margin: '100px 0px' }}><Spin size="large" /></div>}

				{"error" === this.props.workReport.dailyReportStatus && <div style={{ textAlign: 'center', margin: '100px 0px' }}>{webConfig.httpFetchErrorInformation}</div>}
			</div>
		)
	}
}
const mapStateToProps = state => {
	return {
		workReport: state.workReport,
		routing: state.routing,
		employeeManagement: state.employeeManagement,
	}
}
const mapDispatchToProps = {
	increaseDailyReportLoadCounter,
	fetchDailyReportList,
	setDailyReportFilter,
	updateDailyReport,
	submitDailyReport,
	fetchEmployeesList,
}

DailyReport = Form.create()(DailyReport);
export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(DailyReport));





// WEBPACK FOOTER //
// ./src/routes/WorkReport/DailyReport.js